export const createArticleFilter = (els) => {
    const submit = (ev) => {
        ev.preventDefault();
        const params = new URLSearchParams({
            topic: els.topic.value,
        });
        const url = `${location.origin}${location.pathname}?${params}`;
        location.assign(url);
    };
    els.main.addEventListener('submit', submit);
    return {
        submit,
    };
};
